import { useState, useEffect, useRef, useContext, useCallback } from 'react';
import DesktopContext from '../common/DesktopContext';
import config from '../common/config';
import Video from '../../components/Video';

import './styles/Slide.less';

function Slide({ seq, show = false, onEnded, onDataLoaded, ...rest }: any) {
  const [nextVideoKey, setNextVideoKey] = useState(0);
  const [playDigest, setPlayDigest] = useState(false);
  const [playDigest10, setPlayDigest10] = useState(false);
  const [playDigest1, setPlayDigest1] = useState(false);
  const [playDigest5, setPlayDigest5] = useState(false);
  const [playDigest6Text, setPlayDigest6Text] = useState(false);

  const slide = config.slides[seq];
  const videosRef: any = useRef();
  const globalCtx: any = useContext(DesktopContext);

  const restoreInitialState = useCallback(() => {
    if (videosRef.current) {
      const $videos = videosRef.current.querySelectorAll('video');
      $videos.forEach(($v: any, key: number) => {
        $v.currentTime = 0;
        if (slide.videos?.[key].autoPlay === false) $v.pause();
      });
    }
    setNextVideoKey(0);
    setPlayDigest(false);
    setPlayDigest10(false);
    setPlayDigest1(false);
    setPlayDigest5(false);
    setPlayDigest6Text(false);
  }, [videosRef, slide]);

  useEffect(() => {
    if (!show) return;

    if (seq === -5) { // 暂为使用
      setPlayDigest(playDigest5);
    } else if (seq === 10) {
      setPlayDigest(playDigest10);
    } else {
      setPlayDigest(true);
    }
  }, [nextVideoKey, playDigest1, playDigest6Text, playDigest5, playDigest10, seq, show, slide]);

  useEffect(() => {
    if (!show) restoreInitialState();
  }, [show, restoreInitialState]);

  useEffect(() => {
    if (show) {
      if (slide.videos?.[nextVideoKey]?.autoPlay === false) {
        const $videos = videosRef.current.querySelectorAll('video');
        if ($videos[nextVideoKey] && $videos[nextVideoKey].paused) {
          $videos[nextVideoKey].currentTime = 0;
          $videos[nextVideoKey].play();
        }
      }
    }
  }, [show, nextVideoKey, slide, seq]);

  const Digest = slide.digest;

  return (
    <section className={`slide slide-${seq} ${!show ? 'hide' : 'show'}`} {...rest}>
      {Digest && (
        <Digest
          seq={seq}
          play={playDigest}
          {...(seq === 6 ? { playTextBlock: playDigest6Text } : {})}
          onDataLoaded={() => {
            if (onDataLoaded) onDataLoaded(seq);
          }}
        />
      )}
      <div className="videos" ref={videosRef}>
        {slide.videos?.map((videoMeta: any, vKey: number) => {
          return (
            <Video
              video={videoMeta}
              key={vKey}
              onLoadedData={() => {
                if (onDataLoaded) onDataLoaded(seq);
              }}
              onPlaying={() => {
                if (seq === 5) {
                  setPlayDigest5(true);
                }
              }}
              onEnded={(e: any) => {
                if (videoMeta.autoPlayNext) {
                  const $videos = videosRef.current.querySelectorAll('video');
                  if ($videos[nextVideoKey]) {
                    // $videos[nextVideoKey].currentTime = $videos[nextVideoKey].duration;
                    // $videos[nextVideoKey].style.display = 'none';
                  }
                  if ($videos[nextVideoKey + 1]) {
                    setNextVideoKey(nextVideoKey + 1);
                  }
                }
                if (seq === 8) {
                  const $videos = videosRef.current.querySelectorAll('video');
                  $videos[nextVideoKey].currentTime = 2;
                  $videos[nextVideoKey].play();
                }
                if (seq === 10) {
                  setPlayDigest10(true);
                }
                if (onEnded) onEnded();
              }}
              onTimeUpdate={(e: any) => {
                if (seq === 1) {
                  if (e.target.currentTime >= 2) {
                    if (!playDigest1) setPlayDigest1(true);
                  }
                } else if (seq === 6) {
                  if (e.target.currentTime >= 3) {
                    setPlayDigest6Text(true);
                  }
                }
              }}
              style={{ display: nextVideoKey === vKey ? 'block' : 'none' }}
            />
          );
        })}
      </div>
      <div className="to-top-wrapper">
        <div
          className="to-top"
          onClick={(e: any) => {
            e.preventDefault();
            e.stopPropagation();
            globalCtx.dispatch({ type: 'backtop' });
          }}
        >
          <img src={config.getFullUrl('images/top.png')} alt="to top" />
        </div>
      </div>
    </section>
  );
}

export default Slide;
